import { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { CSVLink } from "react-csv";

import CollaboratorService from "../services/CollaboratorService";

const CSV_FILENAME = "Watchson - Relatório de Colaboradores.csv";
const CSV_HEADERS = [
  { label: "NOME", key: "name" },
  { label: "TIME", key: "team_name" },
  { label: "SENIORIDADE", key: "seniority_name" },
  { label: "PROJETO", key: "project_name" },
  { label: "HABILIDADE", key: "skill_name" },
  { label: "CATEGORIA", key: "skill_category" },
  { label: "EXPERIÊNCIA", key: "skill_experience" },
  { label: "ATUALIZADO EM", key: "updated_at" },
  { label: "ADMINISTRADOR", key: "is_admin" },
  { label: "ARQUIVADO", key: "is_archived" },
];

const CollaboratorReportCSV = ({ buttonClassName, buttonVariant }) => {
  const csvLinkRef = useRef(null);
  const [csvData, setCsvData] = useState([]);

  const handleLoadCsvData = async () => {
    const collaborators = await CollaboratorService.getAllToReport();
    if (collaborators.length === 0) {
      return;
    }

    let csvData = [];
    for (const c of collaborators) {
      let data = {
        name: c.user.name,
        team_name: c.team.name,
        seniority_name: c.seniority.name,
        project_name: c.project ? c.project.name : "",
        skill_name: "",
        skill_category: "",
        skill_experience: "",
        updated_at: new Date(c.updated_at).toLocaleString("pt-BR"),
        is_admin: c.user.is_admin ? "SIM" : "NÃO",
        is_archived: c.user.is_archived ? "SIM" : "NÃO",
      };

      if (c.skills.length === 0) {
        csvData.push(data);
      } else {
        for (const s of c.skills) {
          data = {
            ...data,
            skill_name: s.skill.name,
            skill_category: s.skill.category.name,
            skill_experience: s.experience,
          };

          csvData.push(data);
        }
      }
    }

    setCsvData(csvData);
    csvLinkRef.current.link.click();
  };

  return (
    <>
      <CSVLink ref={csvLinkRef} data={csvData} headers={CSV_HEADERS} filename={CSV_FILENAME} target="_self" />
      <Button className={buttonClassName} variant={buttonVariant} onClick={handleLoadCsvData}>
        Exportar Relatório
      </Button>
    </>
  );
};

export default CollaboratorReportCSV;
